export const FETCH_SINGLE_NOTIFICATION_START = "FETCH_SINGLE_NOTIFICATION_START";
export const FETCH_SINGLE_NOTIFICATION_SUCCESS = "FETCH_SINGLE_NOTIFICATION_SUCCESS";
export const FETCH_SINGLE_NOTIFICATION_FAILED = "FETCH_SINGLE_NOTIFICATION_FAILED";

export const FETCH_ALL_NOTIFICATION_START = "FETCH_ALL_NOTIFICATION_START";
export const FETCH_ALL_NOTIFICATION_SUCCESS = "FETCH_ALL_NOTIFICATION_SUCCESS";
export const FETCH_ALL_NOTIFICATION_FAILED = "FETCH_ALL_NOTIFICATION_FAILED";
